import { useEffect, useState } from 'react';

type TImage = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export function ImageReloader(props: TImage): JSX.Element {
	const [error, setError] = useState<boolean>(false);

	useEffect(() => {
		if (error === true) {
			const timeout: NodeJS.Timeout = setTimeout(async () => {
				setError(false);
			}, 4000);

			return () => clearTimeout(timeout);
		}
	}, [error]);

	return <img alt="Network Error" {...props} onError={() => setError(true)} src={error ? '/bobl.png' : props.src} />;
}
